import React from "react";
import PropTypes from "prop-types";
import MUIDataTable from "mui-datatables";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	root: {
		"& .MuiToolbar-root": {
			border: "1px solid #d8d8d8",
			backgroundColor: "rgba(0, 0, 0, 0)"
		},
		"& .MuiButtonBase-root": {
			"&:focus,&:hover": {
				color: theme.palette.primary.main
			}
		},
		"& .MuiTableSortLabel-root": {
			paddingTop: "6px"
		},
		"& .MUIDataTableToolbar-icon": {
			"&:hover": {
				color: theme.palette.primary.main
			}
		},
		"& .MUIDataTableToolbar-iconActive": {
			color: theme.palette.primary.main
		},
		"& .MuiTableRow-hover": {
			cursor: "pointer"
		},
		"& .MuiTablePagination-root:last-child": {
			padding: 0
		},
		"& .MuiTableCell-body": theme.typography.body1,
		"& .MuiInputBase-input": {
            boxShadow: "none !important"
		},
		"& .MuiTableCell-root": {
			zIndex: 0
		}
	}
}));

export default function Table(props) {
	const { title, data, columns, options } = props;
	const classes = useStyles();

	return (
		<MUIDataTable
			className={classes.root}
			title={title}
			data={data}
			columns={columns}
			options={options}
		/>
	);
}

Table.propTypes = {
	title: PropTypes.string,
	data: PropTypes.arrayOf(PropTypes.object).isRequired,
	columns: PropTypes.arrayOf(PropTypes.object).isRequired,
	options: PropTypes.object
};
